import React from 'react';
import { modules } from '../data/modules';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function SystemSection() {
  return <section className="px-4 py-8" data-id="element-141" data-mp="3bimxngbqr96h">
      <div className="mx-auto max-w-4xl text-center" data-id="element-142" data-mp="3bhtvksnq97uo">
        <p className="font-display text-[11px] font-bold uppercase tracking-widest text-gold sm:text-sm" data-id="element-143" data-mp="36jsfmglllonf">
          The Solution You've Been Looking For
        </p>
        <h2 className="mt-1 text-xl font-extrabold leading-tight sm:text-3xl" data-id="element-144" data-mp="31m0dyuv5io61">
          One Complete 6-in-1 Speech Therapy System
        </h2>
        <p className="mt-1 text-sm text-ink-text sm:text-base" data-id="element-145" data-mp="2ss5heb83i620">
          6 Professional Modules In One Complete Operating System
        </p>
        <div className="mt-3 inline-block rounded-lg border border-gold/50 bg-ink-panel px-4 py-2" data-id="element-146" data-mp="2nulwwtkt0x1m">
          <p className="font-display text-sm font-bold uppercase text-white sm:text-lg" data-id="element-147" data-mp="2itpr2agw70tk">
            🗣️ Speech Therapy Pro™
          </p>
          <p className="text-xs text-gold sm:text-sm" data-id="element-148" data-mp="13z7z3dw4eus1">Complete 6-in-1 Operating System</p>
        </div>
        <div className="mx-auto mt-3 max-w-2xl space-y-1 text-sm leading-snug text-ink-text sm:text-base" data-id="element-149" data-mp="18py4gr4jqxmq">
          <p data-id="element-150" data-mp="u1ad6x1qha2l">More than a collection of therapy worksheets.</p>
          <p data-id="element-151" data-mp="u2v5eg0ksgxa">A complete professional system designed to help you:</p>
          <p className="font-semibold text-white" data-id="element-152" data-mp="z16f8qqverfi">
            Plan faster. Deliver better therapy sessions. Stay organized. Save hours every week.
          </p>
        </div>

        <div className="mt-5 grid gap-3 text-left sm:grid-cols-2" data-id="element-153" data-mp="1rpc0delu6ifv">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="group flex gap-3 rounded-xl border border-ink-line bg-ink-panel p-4 transition-colors hover:border-gold" data-id="element-154" data-mp="1crrzais297ez">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gold font-display text-sm font-extrabold text-[#0D0D0D]" data-id="element-155" data-mp="1hsph2u95rzfy">
                {module.num}
              </span>
              <div data-id="element-156" data-mp="6938nalutws3">
                <h3 className="text-[13px] font-bold leading-tight sm:text-base" data-id="element-157" data-mp="28xv4ywkhgfx9">
                  ✅ {module.title}
                </h3>
                <p className="mt-1 text-xs leading-snug text-ink-text sm:text-sm" data-id="element-158" data-mp="240cswxb65kl1">
                  {module.description}
                </p>
              </div>
            </a>)}
        </div>

        <a href={OFFER_ANCHOR} className="mt-5 block" aria-label="Go to the offer" data-id="element-159" data-mp="1u872vt4h9d8h">
          <img src={PRODUCT_IMG} alt="Speech Therapy Pro complete system mockup" className="mx-auto w-full max-w-sm rounded-xl transition-transform duration-200 hover:scale-[1.02]" data-id="element-160" data-mp="1panew1hz9m3c" />
        </a>

        <CTAButton className="mx-auto mt-4 max-w-md" data-id="element-161" data-mp="1g8xmotg9uj4i">
          🚀 YES! I WANT MY SYSTEM NOW
        </CTAButton>
      </div>
    </section>;
}